import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.awaiting_funds_view.title',
        defaultMessage: 'Your funds are on their way!'
    },
    subtitle: {
        id: '_.awaiting_funds_view.subtitle',
        defaultMessage:
            'Thank you for completing your application, we’re processing the transfer of funds and they’ll land in your account as soon as we’ve processed the transfer.'
    }
});
